import { render } from "./BannersComponent.vue?vue&type=template&id=12d246c3"
import script from "./BannersComponent.vue?vue&type=script&lang=js"
export * from "./BannersComponent.vue?vue&type=script&lang=js"

import "./BannersComponent.vue?vue&type=style&index=0&id=12d246c3&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__